import { Select, SelectProps } from 'antd';
import { useStateCsrt } from '@/core/domain/invoice/settings/Settings.hooks';

interface Props extends SelectProps {
  state?: string;
}

const StateCsrtSelect = ({ state, ...props }: Props) => {
  const { data, isFetching } = useStateCsrt(state);

  const options = (data ?? []).map((item) => ({
    value: item.id,
    label: `${item.idCsrt} - ${item.csrt}`,
  }));

  return (
    <Select
      options={options}
      loading={isFetching}
      allowClear
      disabled={!state}
      {...props}
    />
  );
};

export default StateCsrtSelect;
